<template>
  <div class="login">
      
               <div @keydown.enter="submitLogin" class="loginModal">
                <div class="title_con">
                    <div class="title_text">
                       
                    </div>
                    <div class="text1"></div>
                    <!-- <div class="text2">教师端</div> -->
                </div>
                <Form
                    ref="usernameLoginForm"
                    :model="form"
                    :rules="rules"
                    class="form"
                    v-if="tabName=='username'"
                    >
                    <FormItem class="input_class" prop="username">
                        <Input
                        v-model="form.username"
                        size="large"
                        clearable
                        placeholder="请输入用户名"
                        autocomplete="off"
                        />
                    </FormItem>
                    <FormItem class="input_class" prop="password">
                        <Input
                        type="password"
                        v-model="form.password"
                        size="large"
                        placeholder="请输入密码"
                        autocomplete="off"
                        />
                    </FormItem>
                </Form>
                <Button
                    class="login-btn"
                    type="primary"
                    size="large"
                    :loading="loading"
                    @click="submitLogin"
                    long
                >
                    <span v-if="!loading">登录</span>
                    <span v-else>登录中...</span>
                </Button>
           </div>
  </div>
</template>

<script>
import {
  login,
  userInfo,
  organizationInfo,
  getJWT,
  sendLoginSms,
  smsLogin,
  initCaptcha,
  drawCodeImage,
  getOtherSet
} from "@/api/index";
// import { validateMobile } from "@/libs/validate";
import Cookies from "js-cookie";
import util from "@/libs/util.js";
import {postRequest} from '@/libs/axios.js'
import { getStore, setStore } from '@/libs/storage.js';
export default {
  components: {
  },
  data() {
    return {
      captchaId: "",
      captchaImg: "",
      loadingCaptcha: true,
      socialLogining: true,
      error: false,
      tabName: "username",
      saveLogin: true,
      loading: false,
      sending: false,
      errorCode: "",
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "账号不能为空",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          }
        ],
      }
    };
  },
  methods: {
    afterLogin(res) {
      let accessToken = res.result;
      setStore("accessToken", accessToken);
          getOtherSet().then(res => {
            if (res.result) {
              let domain = res.result.ssoDomain;
          Cookies.set("accessToken", accessToken, {
            domain: domain,
            expires: 7
          });
        }
      });
      // 获取用户信息
      userInfo().then(res => {
        if (res.success) {
          // 避免超过大小限制
          delete res.result.permissions;
          let roles = [];
          res.result.roles.forEach(e => {
            roles.push(e.name);
          });
          setStore("roles", roles);
          setStore("saveLogin", this.saveLogin);
          if (this.saveLogin) {
            // 保存7天
            Cookies.set("userInfo", JSON.stringify(res.result), {
              expires: 7
            });
          } else {
            Cookies.set("userInfo", JSON.stringify(res.result));
          }
          // 获取机构信息
          organizationInfo().then(data => {
            if (data.success) {
              if (this.saveLogin) {
              // 保存7天
              Cookies.set("organizationInfo", JSON.stringify(data.result), {
                expires: 7
              });
              } else {
                Cookies.set("organizationInfo", JSON.stringify(data.result));
              }
              // 加载菜单
              util.initRouter(this);
              this.$router.push({
                name: "home_index"
              });
            }
          })
          this.setStore("userInfo", res.result);
          this.$store.commit("setAvatarPath", res.result.avatar);
        } else {
          this.loading = false;
        }
      });
    },
    submitLogin() {
      if (this.tabName == "username") {
        this.$refs.usernameLoginForm.validate(async valid => {
          if (valid) {
            this.loading = true;
            this.form.username = this.form.username.trim()
            this.form.password = this.form.password.trim()
            const res=await postRequest('/v1/techPc/teacherLogin',this.form,true)
            if (res.success === true) {
              this.$util.localSet('accessToken', res.result.accessToken)
              // 处理顶部頁签
              this.$store.state.app.pageOpenedList = [
                {
                  title: '首页',
                  path: '',
                  name: 'home_index'
                }
              ]
            // console.log('ss')
            // this.$router.push('/home')
              // 获取用户信息
              userInfo().then(res => {
                if (res.success === true) {
                  this.$util.localSet('userInfo', res.result);
                  this.$store.commit('setAvatarPath', res.result.avatar);
                  this.$util.initRouter(this)
                  this.$router.push({
                    name: 'home_index'
                  })
                } else {
                  this.loading = false
                }
              })
            } else {
              // PLJ 验证码错误，提示信息
              if (res.code === 10001 || res.code === 10002) {
                this.$Message.error(res.message)
              }
              this.loading = false
            }
          }
        });
      } 
    //   else if (this.tabName == "mobile") {
    //     this.$refs.mobileLoginForm.validate(valid => {
    //       if (valid) {
    //         if (this.form.code == "") {
    //           this.errorCode = "验证码不能为空";
    //           return;
    //         } else {
    //           this.errorCode = "";
    //         }
    //         this.loading = true;
    //         this.form.saveLogin = this.saveLogin;
    //         smsLogin(this.form).then(res => {
    //           if (res.success) {
    //             this.afterLogin(res);
    //           } else {
    //             this.loading = false;
    //           }
    //         });
    //       }
    //     });
    //   }
    },
    relatedLogin() {
      let q = this.$route.query;
      let error = q.error;
      if (error !== "" && error !== undefined) {
        this.$Message.error(error);
      }
      let related = q.related;
      let JWTKey = q.JWTKey;
      if (related && related == "1") {
        if (JWTKey) {
          getJWT({ JWTKey: JWTKey }).then(res => {
            if (res.success) {
              this.socialLogining = true;
              let accessToken = res.result;
              this.setStore("accessToken", accessToken);
              getOtherSet().then(res => {
                if (res.result) {
                  let domain = res.result.ssoDomain;
                  Cookies.set("accessToken", accessToken, {
                    domain: domain,
                    expires: 7
                  });
                }
              });
              // 获取用户信息
              userInfo().then(res => {
                if (res.success) {
                  // 避免超过大小限制
                  delete res.result.permissions;
                  let roles = [];
                  res.result.roles.forEach(e => {
                    roles.push(e.name);
                  });
                  this.setStore("roles", roles);
                  // 保存7天
                  Cookies.set("userInfo", JSON.stringify(res.result), {
                    expires: 7
                  });
                  this.setStore("userInfo", res.result);
                  this.$store.commit("setAvatarPath", res.result.avatar);
                  // 获取机构信息
                  organizationInfo().then(data => {
                    if (data.success) {
                      if (this.saveLogin) {
                      // 保存7天
                      Cookies.set("organizationInfo", JSON.stringify(data.result), {
                        expires: 7
                      });
                      } else {
                        Cookies.set("organizationInfo", JSON.stringify(data.result));
                      }
                      // 加载菜单
                      util.initRouter(this);
                      this.$router.push({
                        name: "home_index"
                      });
                    }
                  })
                } else {
                  this.socialLogining = false;
                  this.$Message.error("使用第三方账号登录失败");
                }
              });
            } else {
              this.socialLogining = false;
              this.$Message.error("使用第三方账号登录失败");
            }
          });
        }
      } else {
        this.socialLogining = false;
      }
    },
    handleDropDown(v) {
      if (v == "resetByMobile") {
        this.$router.push({
          name: "reset"
        });
      } else if (v == "resetByEmail") {
        this.$router.push({
          name: "reset",
          query: {
            type: "1"
          }
        });
      }
    },
    toApply(v) {
      this.$router.push(
        { name: "apply" },
        (onComplete) => {},
        (onAbort) => {}
      );
    },
  },
  mounted() {
    // this.relatedLogin();
    // console.log(this.socialLogining)
  }
};
</script>

<style lang="less">
@import "./login.less";
</style>



// WEBPACK FOOTER //
// src/views/login.vue